module.exports = {
	"nodes": [
		{
			"kind": "block",
			"type": "paragraph",
			"nodes": [
				{
					"kind": "text",
					"text": "In addition to nodes that contain editable text, you can also create other types of nodes, like images or videos."
				}
			]
		},
		{
			"data": {},
			"key": "7ray",
			"kind": "block",
			"isVoid": false,
			"type": "table",
			"nodes": [
				{
					"data": {},
					"key": "oxii",
					"kind": "block",
					"isVoid": false,
					"type": "table_row",
					"nodes": [
						{
							"data": {},
							"key": "hlps",
							"kind": "block",
							"isVoid": false,
							"type": "table_cell",
							"nodes": [
								{
									"data": {
										"src": "https://pixabay.com/static/uploads/photo/2016/07/18/20/33/elephant-1526709__340.jpg"
									},
									"key": "b0d6",
									"kind": "block",
									"isVoid": true,
									"type": "image",
									"nodes": [
										{
											"key": "txbx",
											"kind": "text",
											"ranges": [
												{
													"kind": "range",
													"text": " ",
													"marks": []
												}
											]
										}
									]
								},
								{
									"key": "252k",
									"kind": "text",
									"ranges": [
										{
											"kind": "range",
											"text": "Hello",
											"marks": []
										}
									]
								}
							]
						},
						{
							"data": {},
							"key": "hlps",
							"kind": "block",
							"isVoid": false,
							"type": "table_cell",
							"nodes": [
								{
									"key": "252k",
									"kind": "text",
									"ranges": [
										{
											"kind": "range",
											"text": "",
											"marks": []
										}
									]
								}
							]
						}
					]
				},
				{
					"data": {},
					"key": "4drv",
					"kind": "block",
					"isVoid": false,
					"type": "table_row",
					"nodes": [
						{
							"data": {},
							"key": "iq21",
							"kind": "block",
							"isVoid": false,
							"type": "table_cell",
							"nodes": [
								{
									"key": "l734",
									"kind": "text",
									"ranges": [
										{
											"kind": "range",
											"text": "",
											"marks": []
										}
									]
								}
							]
						},
						{
							"data": {},
							"key": "29ot",
							"kind": "block",
							"isVoid": false,
							"type": "table_cell",
							"nodes": [
								{
									"key": "i9jh",
									"kind": "text",
									"ranges": [
										{
											"kind": "range",
											"text": "",
											"marks": []
										}
									]
								}
							]
						}
					]
				}
			]
		},
		{
			"kind": "block",
			"type": "image",
			"isVoid": true,
			"data": {
				"src": "https://img.washingtonpost.com/wp-apps/imrs.php?src=https://img.washingtonpost.com/news/speaking-of-science/wp-content/uploads/sites/36/2015/10/as12-49-7278-1024x1024.jpg&w=1484",
				"alt": "Hello"
			}
		},
		{
			"kind": "block",
			"type": "ul_list",
			"nodes": [
				{
					"kind": "block",
					"type": "list_item",
					"nodes": [
						{
							"kind": "block",
							"type": "paragraph",
							"nodes": [
								{
									"kind": "text",
									"ranges": [
										{
											"text": "First item in the list"
										}
									]
								}
							]
						}
					]
				},
				{
					"kind": "block",
					"type": "list_item",
					"nodes": [
						{
							"kind": "block",
							"type": "heading",
							"nodes": [
								{
									"kind": "text",
									"ranges": [
										{
											"text": "With blocks:"
										}
									]
								}
							]
						},
						{
							"kind": "block",
							"type": "paragraph",
							"nodes": [
								{
									"kind": "text",
									"ranges": [
										{
											"text": "List item can contain blocks"
										}
									]
								}
							]
						}
					]
				},
				{
					"kind": "block",
					"type": "list_item",
					"nodes": [
						{
							"kind": "block",
							"type": "paragraph",
							"nodes": [
								{
									"kind": "text",
									"ranges": [
										{
											"text": "Third item in the list, with a nested list"
										}
									]
								}
							]
						},
						{
							"kind": "block",
							"type": "ol_list",
							"nodes": [
								{
									"kind": "block",
									"type": "list_item",
									"nodes": [
										{
											"kind": "block",
											"type": "paragraph",
											"nodes": [
												{
													"kind": "text",
													"ranges": [
														{
															"text": "First item in the nested list"
														}
													]
												}
											]
										}
									]
								},
								{
									"kind": "block",
									"type": "list_item",
									"nodes": [
										{
											"kind": "block",
											"type": "paragraph",
											"nodes": [
												{
													"kind": "text",
													"ranges": [
														{
															"text": "Second item in the nested list"
														}
													]
												}
											]
										}
									]
								}
							]
						}
					]
				}
			]
		},
		{
			"kind": "block",
			"type": "paragraph",
			"nodes": [
				{
					"kind": "text",
					"text": "This example shows images in action. It features two ways to add images. You can either add an image via the toolbar icon above, or if you want in on a little secret, copy an image URL to your keyboard and paste it anywhere in the editor!"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/state.json
// module id = 542
// module chunks = 0